// ! Lembrar de alinhar sempre ao que tem no BACKEND
const EventTypeEnum = {
  CADASTRO: 1,
  "ADITIVO DE PRAZO": 2,
  "ADITIVO DE QUANTIDADE": 3,
  "ADITIVO DE REAJUSTE": 4,
  "ADITIVO DE SUPRESSÃO": 5,
  "ADITIVO MODIFICAÇÃO DE ITEM": 6,
  APOSTILAMENTO: 7,
};

export function getEventName(value) {
  return Object.keys(EventTypeEnum).find((key) => EventTypeEnum[key] === value);
}

export default EventTypeEnum;
